<template>
  <div class="banner grid">
    <div class="grid-center">
      <div class="gpt">
        <div :id="bannerAdId" style="width: 300px; height: 250px"></div>
      </div>     
    </div>

    <div class="text-center grid-bottom">
      <button id="0"
              class="btn btn-stretch btn-extra-round text-bold"
              :style="buttonStyle(firstOption.estilo)"
              ref="button"
              @click="$emit('next', firstOption.id)">                 
        {{firstOption.nome}}
      </button>

      <button id="1"
              class="btn btn-stretch btn-extra-round text-bold second"
              v-if="options.length === 2"
              :style="buttonStyle(secondOption.estilo)"
              @click="$emit('next', secondOption.id)">        
        {{secondOption.nome}}
      </button>
    </div>

  </div>
</template>

<script>
import buttonStyle from "../../../../../../interactions/components/interaction/mixins/button-style";

export default {
  components: {
  }, 

  props: {
    dataInteraction: {
      type: Object,
      required: true,
    },
  },


  data() {
    return {
      bannerAdId: `banner-ad-${Date.now()}`
    }
  },

  mounted() {
    this.initGoogleAd();
  },

  methods: {
    initGoogleAd() {
      window.googletag = window.googletag || { cmd: [] };

      googletag.cmd.push(() => {
        googletag.pubads().addEventListener('slotRenderEnded', function (event) {
          if (event.isEmpty) {
            googletag.cmd.push(() => {
              googletag.pubads().refresh();
            });
          }
        });
      });

      googletag.cmd.push(() => {
          googletag
              .defineSlot("/6355419/Travel/Europe/France/Paris", [300, 250], this.bannerAdId)
              .addService(googletag.pubads());
              
          googletag.enableServices();
      });

      googletag.cmd.push(() => {
        googletag.display(this.bannerAdId);
      });
    }
  },

  computed: {
    options() {
      return this.dataInteraction.opcoes;
    },

    firstOption() {
      return (
        this.options[0] || {
          estilo: null,
          nome: null,
        }
      );
    },

    secondOption() {
      return (
        this.options[1] || {
          estilo: null,
          nome: null,
        }
      );
    },

    itemStyle() {
      return this.dataInteraction.estilo ? this.dataInteraction.estilo : null
    },
   
  },

  mixins: [buttonStyle],
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.banner {
  .gpt {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  &.grid {
    .grid-center{
      margin: 0 auto;
    }
    .grid-bottom {
      gap: 2.5%;
      margin: 0 2.5%;
    }
  }
}
</style>
